import React from "react";
import Space from "components/Space";
import { Button, Icon, Input } from "antd";
import Form from "rc-field-form";
import styles from "./index.module.scss";
import { isTrue } from "../../../../../service/service";

interface QueryFormProps {
    onChange(keyword: string): void;
    setSort: (sort: BooleanValue) => void;
    sort: BooleanValue;
}

export default function QueryForm({ onChange, sort, setSort }: QueryFormProps) {
    function toggle() {
        setSort(isTrue(sort) ? "0" : "1");
    }
    return (
        <div className={styles.root}>
            <Space>
                <Button type="link" onClick={toggle}>
                    时间排序
                    <Icon
                        type={
                            isTrue(sort) ? "sort-ascending" : "sort-descending"
                        }
                    />
                </Button>
            </Space>

            <Form
                className={styles.search}
                onFinish={data => onChange(data.keyword)}>
                <Form.Field name="keyword">
                    <Input
                        placeholder="请输入课程名称、课编号或问题关键字搜索"
                        maxLength={100}
                    />
                </Form.Field>

                <Button type="primary" icon="search" htmlType="submit">
                    查询
                </Button>
            </Form>
        </div>
    );
}
